import React from 'react';
import { Router, Route, Switch, withRouter } from 'react-router';
import withRole from 'components/Security/withRole';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';
import {
  ROLE_CREATE_DIET,
  ROLE_EDIT_DIET,
  ROLE_SHOW_DIET,
} from 'helpers/roles';

import List from './List';
import Form from './Form';

const Diets = props => {
  const { history, match } = props;
  const ListSecured = withRole(ROLE_SHOW_DIET, List);
  const CreateForm = withRole(ROLE_CREATE_DIET, Form);
  const EditForm = withRole(ROLE_EDIT_DIET, Form);

  return (
    <DataGridStateContextProvider>
      <Router history={history}>
        <Switch>
          <Route
            exact={true}
            path={`${match.url}/`}
            render={parentProps => <ListSecured {...props} {...parentProps} />}
          />
          <Route
            path={`${match.url}/add`}
            render={() => <CreateForm {...props} />}
          />
          <Route
            path={`${match.url}/edit/:id`}
            render={parentProps => <EditForm {...props} {...parentProps} />}
          />
        </Switch>
      </Router>
    </DataGridStateContextProvider>
  );
};

export default withRouter(Diets);
